import { Box } from '@material-ui/system';
import { FC, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Alert, Tab, Tabs, Typography } from '@material-ui/core';
import useIsMountedRef from '../../../../hooks/useIsMountedRef';
import { onGet } from '../../../../store/actions/global';
import Prospeccion from './components/Prospeccion';
import Filter from './Filter';
import Proceso from './components/Proceso';
import RemesaRRHH from './components/RemesaRRHH';
import MesaDeControl from './components/MesaDeControl';
import AnalisisYAlta from './components/AnalisisYAlta';
import Formalizador from './components/Formalizador';

interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={0} pt={3} pb={3}>
          <Typography component="span">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

const IngresosAtencion: FC<any> = ({ onGet: onGetExec }) => {
  const isMountedRef = useIsMountedRef();
  const [valueTab, setValueTab] = useState(0);
  // const [stopEffect, setStopEffect] = useState(true);
  const [messageError, setMessageError] = useState('');
  const [spinner, setSpinner] = useState({ prospeccion: false, proceso: false, remesa: false, mesaControl: false, analisisAlta: false, formalizador: false });
  const [dataProspeccion, setDataProspeccion] = useState({
    data: [],
  });
  const [dataProceso, setDataProceso] = useState({
    data: [],
  });
  const [dataRemesaRRHH, setDataRemesaRRHH] = useState({
    data: [],
  });
  const [dataMesaDeControl, setDataMesaDeControl] = useState({
    data: [],
  });
  const [dataAnalisisYAlta, setDataAnalisisYAlta] = useState({
    data: [],
  });
  const [dataFormalizador, setDataFormalizador] = useState({
    data: [],
  });

  const [formFilter, setFormFilter] = useState({
    startDate: new Date(),
    endDate: new Date(),
    modo: 'canal'
  });

  const getDateString = (dateParam: Date): string => {
    const month = dateParam.getMonth() + 1;
    const day = dateParam.getDate();
    const monthString = month > 9 ? `${month}` : `0${month}`;
    const dayString = day > 9 ? `${day}` : `0${day}`;
    return `${dateParam.getFullYear()}-${monthString}-${dayString}`;
  };

  const [pastFilterProspeccion, setPastFilterProspeccion] = useState({ startDate: '', endDate: '', filter: '' });
  const [pastFilterProceso, setPastFilterProceso] = useState({ startDate: '', endDate: '', filter: '' });
  const [pastFilterRemesa, setPastFilterRemesa] = useState({ startDate: '', endDate: '', filter: '' });
  const [pastFilterEveris, setPastFilterEveris] = useState({ startDate: '', endDate: '', filter: '' });
  const [submitFilter, setSubmitFilter] = useState({ startDate: getDateString(formFilter.startDate), endDate: getDateString(formFilter.endDate), filter: 'canal' });

  const calcularTotal = (categoria, data) => data.reduce((total, item) => total + parseFloat(item[categoria]), 0);
  const totalRowTotalCol = (res) => {
    if (res.length > 0) {
      // total col
      const resYTotal = res.map((resRow) => ({
        ...resRow,
        total: Object.entries(resRow).filter(([clave]) => clave.endsWith('_numero') && !clave.endsWith('rechazado_numero')).map(([, valor]) => valor) // filtra los terminados en monto y devuelve el valor
          .map((numeroStr) => Number(numeroStr)) // transforma a numero
          .reduce((total, numero) => total + numero, 0), // suma todo el array
      }));
      // total row
      const categorias = Object.keys(resYTotal[0]);
      const totalObjeto = {
        nombreComercial: 'TOTAL',
      };
      categorias.forEach((categoria) => {
        if (categoria !== 'nombreComercial' && categoria !== 'detail') {
          const total = calcularTotal(categoria, resYTotal).toFixed(2);
          const numberWithCommas = parseFloat(total).toLocaleString(undefined, { maximumFractionDigits: 2 });
          totalObjeto[categoria] = numberWithCommas;
          if (categoria.endsWith('porcentaje')) {
            totalObjeto[categoria] = '0.00';
          }
        }
      });
      resYTotal.push(totalObjeto);
      return resYTotal;
    }
    return res;
  };

  const onSubmitProspeccion = async (body: any) => {
    try {
      setSpinner((values) => ({ ...values, prospeccion: true }));
      const res = await onGetExec({
        url: '/dashboard/ingresos-atencion/prospeccion',
        body,
        global: false,
      });
      setDataProspeccion({
        data: totalRowTotalCol(res), // totalRowTotalCol(res.map((e) => ({ ...e, detail: res }))),
      });
      setSpinner((values) => ({ ...values, prospeccion: false }));
    } catch (error) {
      console.log(error);
      setMessageError(error);
    }
  };

  const onSubmitProceso = async (body: any) => {
    try {
      setSpinner((values) => ({ ...values, proceso: true }));
      const res = await onGetExec({
        url: '/dashboard/ingresos-atencion/proceso',
        body,
        global: false,
      });
      setDataProceso({
        data: totalRowTotalCol(res),
      });
      setSpinner((values) => ({ ...values, proceso: false }));
    } catch (error) {
      console.log(error);
      setMessageError(error);
    }
  };
  const onSubmitRemesa = async (body: any) => {
    try {
      setSpinner((values) => ({ ...values, remesa: true }));
      const res = await onGetExec({
        url: '/dashboard/ingresos-atencion/remesa',
        body,
        global: false,
      });
      setDataRemesaRRHH({
        data: totalRowTotalCol(res),
      });
      setSpinner((values) => ({ ...values, remesa: false }));
    } catch (error) {
      console.log(error);
      setMessageError(error);
    }
  };
  const onSubmitMesaControl = async (body: any) => {
    try {
      setSpinner((values) => ({ ...values, mesaControl: true }));
      const res = await onGetExec({
        url: '/dashboard/ingresos-atencion/mesa-control',
        body,
        global: false,
      });
      setDataMesaDeControl({
        data: totalRowTotalCol(res),
      });
      setSpinner((values) => ({ ...values, mesaControl: false }));
    } catch (error) {
      console.log(error);
      setMessageError(error);
    }
  };
  const onSubmitAnalisisAlta = async (body: any) => {
    try {
      setSpinner((values) => ({ ...values, analisisAlta: true }));
      const res = await onGetExec({
        url: '/dashboard/ingresos-atencion/analisis-alta',
        body,
        global: false,
      });
      setDataAnalisisYAlta({
        data: totalRowTotalCol(res),
      });
      setSpinner((values) => ({ ...values, analisisAlta: false }));
    } catch (error) {
      console.log(error);
      setMessageError(error);
    }
  };
  const onSubmitFormalizador = async (body: any) => {
    try {
      setSpinner((values) => ({ ...values, formalizador: true }));
      const res = await onGetExec({
        url: '/dashboard/ingresos-atencion/formalizador',
        body,
        global: false,
      });
      setDataFormalizador({
        data: totalRowTotalCol(res),
      });
      setSpinner((values) => ({ ...values, formalizador: false }));
    } catch (error) {
      console.log(error);
      setMessageError(error);
    }
  };

  const onSubmit = async () => {
    if (isMountedRef.current) {
      try {
        const startDate = getDateString(formFilter.startDate);
        const endDate = getDateString(formFilter.endDate);
        const { modo } = formFilter;
        const body = { startDate, endDate, filter: modo };
        if (JSON.stringify(submitFilter) !== JSON.stringify(body)) {
          setSubmitFilter(body);
          if (valueTab === 0) {
            await onSubmitProspeccion(body);
          } else if (valueTab === 1) {
            await onSubmitProceso(body);
          } else if (valueTab === 2) {
            await onSubmitRemesa(body);
          } else if (valueTab === 3) {
            await onSubmitMesaControl(body);
            await onSubmitAnalisisAlta(body);
            await onSubmitFormalizador(body);
          } else {
            await onSubmitProspeccion(body);
          }
        }
      } catch (error) {
        console.log(error);
        setMessageError(error);
      }
    }
  };

  const changeFilter = (name, value) => {
    setFormFilter((values) => ({
      ...values,
      [name]: value,
    }));
  };

  const handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
    setValueTab(newValue);
  };

  if (messageError) {
    return <Alert severity="error">{messageError}</Alert>;
  }

  useEffect(() => {
    const cargarData = async () => {
      if (isMountedRef.current) {
        try {
          const body = submitFilter;
          if (valueTab === 0 && (submitFilter !== pastFilterProspeccion)) {
            await onSubmitProspeccion(body);
            setPastFilterProspeccion(body);
          } else if (valueTab === 1 && (submitFilter !== pastFilterProceso)) {
            await onSubmitProceso(body);
            setPastFilterProceso(body);
          } else if (valueTab === 2 && (submitFilter !== pastFilterRemesa)) {
            await onSubmitRemesa(body);
            setPastFilterRemesa(body);
          } else if (valueTab === 3 && (submitFilter !== pastFilterEveris)) {
            await onSubmitMesaControl(body);
            await onSubmitAnalisisAlta(body);
            await onSubmitFormalizador(body);
            setPastFilterEveris(body);
          } else {
            return;
          }
        } catch (error) {
          console.log(error);
          setMessageError(error);
        }
      }
    };
    cargarData();
  }, [valueTab]);

  return (
    <Box mt={2}>
      <Filter
        onSubmit={onSubmit}
        formFilter={formFilter}
        changeFilter={changeFilter}
      />
      <Box mt={3}>
        <Tabs value={valueTab} onChange={handleChangeTab} variant="fullWidth" aria-label="simple tabs example" textColor="inherit">
          <Tab label="Prospección" />
          <Tab label="Proceso" />
          <Tab label="Remesa" />
          <Tab label="Everis" />
        </Tabs>
      </Box>
      <TabPanel value={valueTab} index={0}>
        <Prospeccion content={dataProspeccion} spinner={spinner.prospeccion} channel={formFilter.modo} body={formFilter} onGet={onGetExec} />
      </TabPanel>
      <TabPanel value={valueTab} index={1}>
        <Proceso content={dataProceso} spinner={spinner.proceso} channel={formFilter.modo} />
      </TabPanel>
      <TabPanel value={valueTab} index={2}>
        <RemesaRRHH content={dataRemesaRRHH} spinner={spinner.remesa} channel={formFilter.modo} />
      </TabPanel>
      <TabPanel value={valueTab} index={3}>
        <MesaDeControl content={dataMesaDeControl} spinner={spinner.mesaControl} channel={formFilter.modo} />
        <AnalisisYAlta content={dataAnalisisYAlta} spinner={spinner.analisisAlta} channel={formFilter.modo} />
        <Formalizador content={dataFormalizador} spinner={spinner.formalizador} channel={formFilter.modo} />
      </TabPanel>
    </Box>
  );
};

export default connect(null, {
  onGet,
})(IngresosAtencion);
